export { Table } from './Table';
export { TableProps, TableDataType, TableColumn } from './types';
